import React, { useCallback, useEffect, useState } from 'react';
import cn from 'classnames';
import { BsChevronUp } from 'react-icons/bs';
import useIsServer from 'hooks/useIsServer';
import styles from './ScrollTopButton.module.scss';

const START_DISPLAY_SCROLL_TOP_FROM = 30;

const ScrollTopButton = () => {
  const isServer = useIsServer();
  if (isServer) {
    return null;
  }

  const [isVisible, showScrollTop] = useState<boolean>(false);

  const listenScrollPosition = useCallback(() => {
    if (window.scrollY > START_DISPLAY_SCROLL_TOP_FROM) {
      showScrollTop(true);
    } else {
      showScrollTop(false);
    }
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', listenScrollPosition);
    listenScrollPosition();
    return () => {
      window.removeEventListener('scroll', listenScrollPosition);
    };
  }, []);

  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };
  return (
    <div
      className={cn(styles.scrollTop, {
        [styles.show]: isVisible,
      })}
      onClick={scrollTop}
    >
      <BsChevronUp />
    </div>
  );
};

export default ScrollTopButton;
